import * as React from "react";
import { SVGProps } from "react";

const Chainlink = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37 43" {...props}>
    <path
      fill="#2a5ada"
      d="m18.9 0-4 2.3L4 8.6l-4 2.3v21.8L4 35l11 6.3 4 2.3 4-2.3L33.8 35l4-2.3V10.9l-4-2.3-10.9-6.3ZM8 28.1V15.5l10.9-6.3 10.9 6.3v12.6l-10.9 6.3Z"
    />
  </svg>
);

export default Chainlink;
